import {EduNavbar} from "../education/EduNavbar";
import {ExpNav} from "./ExpNav";

export const Exp1 = () => {
    return (
        <div className="experience">
            <ExpNav/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 style={{margin:"50px",padding:"20px"}}>Backend Design Engineer - Intel Corporation - Austin</h1>

            <p style={{fontSize:"x-large",margin:"20px",padding:"20px"}}>Graduate Co-op Internship : Jun 2022 - May 2023 </p>

            <ul style={{fontSize:"x-large",margin:"20px",padding:"30px",textAlign:"left"}}>
                <li>Perl scripting for automation of various reports generated by the tool after DRC and LVS runs.</li>
                <li>Performed module placement and routing using TCL scripting and Synopsis Fusion Compiler.</li>
                <li>Executed the complete Place and Route (PNR) flow and successfully signed off the module with DRC and LVS pass.</li>
                <li>Conducted feed-through routing using Synopsys Fusion Compiler.</li>
            </ul>

            <br/>



        </div>
    )
}